/* lua.js generated code 0.3.0 */

require("clover/panel/component/common/UIGroupButton")
UIGIconNumLabelButton = xClass("UIGIconNumLabelButton", UIGroupButton, function(node){
    return node
})
UIGIconNumLabelButton.prototype.ctor = function (node, swallowTouch) {
    var self = this
    UIGroupButton.prototype.ctor.call(self, node, swallowTouch)
    self.minMargin = 5
    self.maxMargin = 15
    self.rightMargin = 0
    self.getChildByName("label").setScale(1)
}
UIGIconNumLabelButton.prototype.getLabelString = function () {
    let self = this
    let label = self.getChildByName("label")
    if (label) {
        return label.getString()
    }
}
UIGIconNumLabelButton.prototype.getNum = function () {
    let self = this
    let num = self.getChildByName("num")
    if (num) {
        return num.getString()
    }
}
UIGIconNumLabelButton.prototype.setString = function (str) {
    var self = this
    var bg = self.getChildByName("normal")
    var bgSize = bg.getContentSize()
    ;[bgSize.width, bgSize.height] = [bgSize.width - 10.9, bgSize.height - 22.35]
    var [xOffset, yOffset] = [0, 1]
    var label = self.getChildByName("label")
    if (_G.__use_small_res) {
        if (!self.scaleLabel) {
            self.scaleLabel = label.getScale()
        }
        label.setScale(self.scaleLabel * 0.9)
    }
    label.ignoreContentAdaptWithSize(true)
    label.setString(str)
    var size = label.getVirtualRendererSize()
    var scale = label.getScale()
    label.setPositionY(bg.getPositionY() - (bgSize.height - size.height * scale) * 3 / 5 - yOffset)
    self.refreshLayout()
}
UIGIconNumLabelButton.prototype.setNum = function (str) {
    var self = this
    var bg = self.getChildByName("normal")
    var bgSize = bg.getContentSize()
    ;[bgSize.width, bgSize.height] = [bgSize.width - 10.9, bgSize.height - 22.35]
    var [xOffset, yOffset] = [0, 8]
    var label = self.getChildByName("num")
    if (_G.__use_small_res) {
        if (!self.scaleNum) {
            self.scaleNum = label.getScale()
        }
        label.setScale(self.scaleNum * 0.9)
    }
    label.ignoreContentAdaptWithSize(true)
    label.setString(str)
    var size = label.getVirtualRendererSize()
    var scale = label.getScale()
    // label.setPositionY(bg.getPositionY() - (bgSize.height - size.height * scale) * 10 / 39 - yOffset)
    label.setPositionY(bg.getPositionY() - (bgSize.height - size.height * scale) * 2 / 5 - yOffset)
    self.refreshLayout()
}
UIGIconNumLabelButton.prototype.setIcon = function (sprite) {
    var self = this
    var bg = self.getChildByName("normal")
    var bgSize = bg.getContentSize()
    ;[bgSize.width, bgSize.height] = [bgSize.width - 10.9, bgSize.height - 22.35]
    var [xOffset, yOffset] = [0, 0]
    var icon = self.getChildByName("icon")
    var iSize = icon.getContentSize()
    icon.setPositionY(bg.getPositionY() - bgSize.height / 2 - yOffset)
    var size = sprite.getContentSize()
    sprite.setScale(iSize.width * icon.getScale() / size.width)
    sprite.setName("icon")
    sprite.setPosition(cc.p(icon.getPosition()))
    icon.removeFromParent(true)
    self.addChild(sprite)
    self.refreshLayout()
}
// 刷新横向布局
UIGIconNumLabelButton.prototype.refreshLayout = function () {
    var self = this
    var bg = self.getChildByName("normal")
    var bSize = bg.getContentSize()
    ;[bSize.width, bSize.height] = [bSize.width - 10.9, bSize.height - 22.35]
    var icon = self.getChildByName("icon")
    var iSize = icon.getContentSize()
    var num = self.getChildByName("num")
    var nSize = num.getContentSize()
    nSize = { width: nSize.width * num.getScaleX(), height: nSize.height * num.getScaleY() }
    var label = self.getChildByName("label")
    var lSize = label.getContentSize()
    var totalWidth = iSize.width * icon.getScale() + Math.max(nSize.width, 60) + lSize.width
    margin = Math.max(Math.min((bSize.width - self.rightMargin - totalWidth - 30) / 2, self.maxMargin), self.minMargin)
    num.setPositionX(icon.getPositionX() + iSize.width * icon.getScale() / 2 + margin + (Math.max(nSize.width, 60) - nSize.width) / 2 + 12)
    label.setPositionX(icon.getPositionX() + iSize.width * icon.getScale() / 2 + margin * 2 + Math.max(nSize.width, 60) + 25)
}
